import { useEffect, useState } from 'react';
import { CITIES } from '@belong/common';
import { Image, Modal, Text, Button } from '@belong/ui';
import { kebabCase } from 'es-toolkit/compat';
import { NewPropertyModel } from 'src/api/models';
import { INVALID_ZIPCODE } from 'src/constants/address';
import { NOT_THERE_YET_STRINGS as STRINGS } from './strings';

const COVERAGE_IMAGE_BASE_PATH = '/coverage_areas/v2/belong_coverage_area_map';
const ALL_COVERAGE_IMAGE_BASE_PATH = `${COVERAGE_IMAGE_BASE_PATH}_all_v14.svg`;
const MAXIMUM_CITY_NAME_LENGTH = 20;

function getCoverageImagePath(property: NotThereYetProps['property']) {
  const foundCity = CITIES.find((city) => city.city.toLowerCase() === property.address.city.toLowerCase());

  if (foundCity) {
    return `${COVERAGE_IMAGE_BASE_PATH}_${kebabCase(foundCity.region)}.jpg`;
  }

  return foundCity;
}

// FIX MOBILE PADDING
export function NotThereYet({
  isOpen,
  onDismiss,
  property,
  title = STRINGS.title,
  subtitle = STRINGS.subtitle_x,
}: NotThereYetProps): JSX.Element {
  const [coverageImage, setCoverageImage] = useState(
    getCoverageImagePath(property) ? getCoverageImagePath(property) || '' : ALL_COVERAGE_IMAGE_BASE_PATH
  );

  const city = property.address.city !== 'Washington' ? property.address.city : 'Washington DC';
  const noZipcode = property?.address?.zipcode === INVALID_ZIPCODE;
  const CityText = () => (
    <>
      {city.length > MAXIMUM_CITY_NAME_LENGTH ? <br /> : ' '}
      {`${city}.`}
    </>
  );

  function onCoverageImageError() {
    setCoverageImage(ALL_COVERAGE_IMAGE_BASE_PATH);
  }

  useEffect(() => {
    setCoverageImage(
      getCoverageImagePath(property) ? getCoverageImagePath(property) || '' : ALL_COVERAGE_IMAGE_BASE_PATH
    );
  }, [property]);

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} name="not_there_yet">
      <div className="pt-lg pb-xl">
        <div className="container flex flex-col items-center">
          <Text variant="h2" fontWeight="semibold" className="text-center">
            {noZipcode ? STRINGS['no_zip_code.title'] : title}
            {!noZipcode && <CityText />}
          </Text>
          <div className="mb-sm">
            <Text variant="h2" fontWeight="semibold" className="text-center">
              {noZipcode ? STRINGS['no_zip_code.subtitle'] : subtitle}
            </Text>
          </div>

          <div className="mb-xl">
            <Text className="text-center">
              {STRINGS['form.title']} <CityText />
            </Text>
          </div>
        </div>
        <div className="w-full mb-xl">
          <Image src={coverageImage} alt="" onError={onCoverageImageError} />
        </div>
        <div className="container flex flex-col items-center">
          <Button onClick={onDismiss} variant="text" size="fluid">
            {STRINGS['no.thanks']}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export type NotThereYetProps = {
  isOpen: boolean;
  onDismiss: () => void;
  property: NewPropertyModel;
  title?: string;
  subtitle?: string;
};
